import {
  chartDataRefKey,
  configRefKey,
  maintenanceRefKey, pilotDataRefKey,
} from 'config/config';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, get } from 'firebase/database';
import { getAnalytics, logEvent } from 'firebase/analytics';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// 주의!! databaseURL만 이상하게 env에서 정의하면 인식이 안되는 오류가 있어서 여기에 박아 둠
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_apiKey,
//   authDomain: process.env.REACT_APP_authDomain,
//   projectId: process.env.REACT_APP_projectId,
//   storageBucket: process.env.REACT_APP_storageBucket,
//   messagingSenderId: process.env.REACT_APP_messagingSenderId,
//   appId: process.env.REACT_APP_appId,
//   measurementId: process.env.REACT_APP_measurementId,
//   databaseURL:
//     'https://perplayweb-default-rtdb.asia-southeast1.firebasedatabase.app',
// };
// const firebaseConfig = {
//   apiKey: 'AIzaSyDKvL0Ia55eRgFYqrjU674_5qeF-CRXajM',
//   authDomain: 'perplayweb.firebaseapp.com',
//   databaseURL:
//     'https://perplayweb-default-rtdb.asia-southeast1.firebasedatabase.app',
//   projectId: 'perplayweb',
//   storageBucket: 'perplayweb.appspot.com',
//   messagingSenderId: '272194475648',
//   appId: '1:272194475648:web:e9b998efcdb55965cd3865',
//   measurementId: 'G-2G71V2EQVT',
// };
const firebaseConfig = {
  apiKey: 'AIzaSyCUnL5LiKjw1AXCV0GSUMuRp1wABS_GrtA',
  authDomain: 'perplayweb-6b5f3.firebaseapp.com',
  databaseURL:
      'https://perplayweb-6b5f3-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'perplayweb-6b5f3',
  storageBucket: 'perplayweb-6b5f3.firebasestorage.app',
  messagingSenderId: '892698135013',
  appId: '1:892698135013:web:397e938c98482dab2e470c',
  measurementId: 'G-DP4PESS7YW',
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// Initialize Analytics and get a reference to the service
const analytics = getAnalytics(firebaseApp);
// Initialize RealTimeDB and get a reference to the service
const db = getDatabase();

export const getChartData = async () => {
  const _ref = ref(db, chartDataRefKey);

  try {
    const snapshot = await get(_ref);
    return snapshot.val();
  } catch (e) {
    console.error('getChartData', e);
  }
};

export const configRef = ref(db, configRefKey);
export const maintenanceRef = ref(db, maintenanceRefKey);
export const pilotDataRef = ref(db, pilotDataRefKey);
export const serverTimeRef = ref(db, '.info/serverTimeOffset'); // 서버 시간(특수 경로)

// onValue를 사용하여 config를 가져올 때는 unscribe를 해야 하므로
// 사용하는 곳에서 useEffect를 사용하여 직접 처리한다.

export const getConfigData = async () => {
  const _ref = ref(db, configRefKey);

  try {
    const snapshot = await get(_ref);
    return snapshot.val();
  } catch (e) {
    console.error('getConfigData', e);
  }
};

// 애널리틱스 이벤트

/**
 * 기어 구매 버튼 클릭 시 로그를 남긴다.
 * @param {{itemId: String, itemName: String, tier: number, price: number, amount: number, }} info
 */
export const logEventBeginPurchase = (info) => {
  const item = {
    item_id: info.itemId ?? 'empty',
    item_name: info.itemName ?? '',
  };

  const params = {
    tier: info.tier ?? 0,
    currency: 'USDT',
    price: info.price ?? 0,
    amount: info.amount ?? 0,
    total: info.price * info.amount,
    items: [item],
  };

  logEvent(analytics, 'begin_checkout', params);
};

/**
 * 기어 구매 시 로그를 남긴다.
 * @param {{itemId: String, itemName: String, txId: String, tier: number, price: number, amount: number, }} info
 */
export const logEventPurchase = (info) => {
  const item = {
    item_id: info.itemId ?? 'empty',
    item_name: info.itemName ?? '',
  };

  const params = {
    transaction_id: info.txId,
    tier: info.tier ?? 0,
    currency: 'USDT',
    price: info.price ?? 0,
    amount: info.amount ?? 0,
    total: info.price * info.amount,
    items: [item],
  };

  logEvent(analytics, 'purchase', params);
};

export default firebaseApp;
